import { render } from "./ChoosePrompt.vue?vue&type=template&id=2c43d604&scoped=true"
import script from "./ChoosePrompt.vue?vue&type=script&lang=js"
export * from "./ChoosePrompt.vue?vue&type=script&lang=js"

import "./ChoosePrompt.vue?vue&type=style&index=0&id=2c43d604&scoped=true&lang=css"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=2c43d604&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c43d604"]])

export default __exports__